import './styles/index.sass'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vtime from './utils/vtime'
import components from 'byod'
import apis from './apis'
import alert from './utils/alert.js'
import globalLoading from './utils/globalLoading.js'
import VueQrcode from '@chenfengyuan/vue-qrcode'
import './utils/style.sass'
import './directives/scroll.js'
import './directives/click-outside.js'
import {
	countOrderPrice,
	countProductPrice,
	getOrderTotal,
} from '@/utils/order'
import { stepPrice } from '@/utils/stepPrice'
import 'regenerator-runtime/runtime'
import VueMeta from 'vue-meta'
import { initChunkErrorHandler } from '@/utils/chunkErrorHandler'
import storeManager from '@/utils/storeManager'
import { bootGate } from './utils/gate.js'
import { cleanupExpiredTransactions } from '@/utils/transactionGuard'

Vue.config.productionTip = false

// 初始化 ChunkLoadError 處理器
initChunkErrorHandler()

// 清理過期的交易記錄
cleanupExpiredTransactions()

Vue.prototype.$countProductPrice = countProductPrice
Vue.prototype.$countOrderPrice = countOrderPrice
Vue.prototype.$getOrderTotal = getOrderTotal
Vue.prototype.$stepPrice = stepPrice
Vue.prototype.$vtime = vtime
Vue.prototype.$env = process.env
Vue.prototype.$storeManager = storeManager
Vue.use(alert)
Vue.use(globalLoading)
Vue.use(components)
Vue.use(apis)
Vue.component(VueQrcode.name, VueQrcode)
Vue.use(VueMeta)

window.$devLog = (...args) => {
	if (process.env.NODE_ENV === 'development') {
		const log = console[args[0]]
		if (log) {
			log(...args.slice(1))
		} else {
			console.log(...args)
		}
	}
}

window.$jsonLog = (...args) => {
	if (process.env.NODE_ENV === 'development') {
		const formattedArgs = args.map(arg =>
			typeof arg === 'object' ? JSON.stringify(arg, null, 2) : arg,
		)

		const log = console[formattedArgs[0]]
		if (log) {
			log(...formattedArgs.slice(1))
		} else {
			console.log(...formattedArgs)
		}
	}
}

router.beforeEach(async (to, from, next) => {
	try {
		await bootGate.whenReady('main.js') // 等初始化開門（逾時會丟 GATE_TIMEOUT）
	} catch (e) {
		console.log(e)
	}

	const qrCodeHash = to.params.random

	if (qrCodeHash) {
		storeManager.updateFromRoute(qrCodeHash, store.state.user.storeInfo)
	}

	if (location.hash.startsWith('#/')) {
		location.replace(location.pathname + location.hash.slice(2))
	}

	if (
		to.fullPath === `/${qrCodeHash}/Order` ||
		to.fullPath === `/${qrCodeHash}/Cart` ||
		to.fullPath.startsWith(`/${qrCodeHash}/Detail/${to.params.id}`)
	) {
		if (!store.getters.canBuy) {
			next(`/${qrCodeHash}/Store`)
			if (to.meta.title) {
				document.title = to.meta.title
			}
		} else {
			next()
		}
	} else if (to.name === `Main`) {
		next(`/${qrCodeHash}/Store`)
	} else {
		next()
	}
})

new Vue({
	router,
	store,
	render: h => h(App),
}).$mount('#app')
